import type { IconName } from '~/components/global/MBZ/Icon.vue';

export function getIconAnimationClass(iconName: IconName | null) {
  if (!iconName || iconName === 'times') return '';

  return iconName === 'arrowLeft'
    ? 'group-hover:translate-x-[-0.225rem] transition-transform duration-300 ease-in-out'
    : 'group-hover:translate-x-[0.225rem] transition-transform duration-300 ease-in-out';
}
